import { VerticalTab } from '../../../shared/components/tabs/vertical-tabs/vertical-tabs.component';

export const MY_ACCOUNT_PERSONAL_TABS: VerticalTab[] = [
  {
    name: 'Account Settings',
    icon: 'icon-user-circle-outline',
    routerLink: '/my-account/personal/account-settings'
  },
  {
    name: 'My Orders',
    icon: 'icon-cart',
    routerLink: '/my-account/personal/orders'
  },
  // TODO: Uncomment once backend provides responses
  // {
  //   name: 'My Subscriptions',
  //   icon: 'icon-refresh-outline',
  //   routerLink: '/my-account/personal/subscriptions'
  // },
  {
    name: 'Payment Methods',
    icon: 'icon-credit-card-outline',
    routerLink: '/my-account/personal/payment-methods'
  },
  {
    name: 'Saved Address',
    icon: 'icon-pin-outline',
    routerLink: '/my-account/personal/saved-addresses'
  },
  {
    name: 'Update Password',
    icon: 'icon-lock-outline',
    routerLink: '/my-account/personal/update-password'
  },
  {
    name: 'Gift Cards & Rewards',
    icon: 'icon-tag-outline',
    routerLink: '/my-account/personal/gift-rewards'
  }
  // TODO: Uncomment once backend provides responses
  // {
  //   name: 'Coupons',
  //   icon: 'icon-coupon-outline',
  //   routerLink: '/my-account/personal/coupons'
  // },
  // {
  //   name: 'Referrals',
  //   icon: 'icon-share-outline',
  //   routerLink: '/my-account/personal/referrals'
  // }
];
